import Input from "input-format/react";

import { cn } from "~/components/ui/cn";

export type SwiftInputProps = {
  value?: string;
  defaultValue?: string;
  onChange?(value?: string): void;
  onKeyDown?(value?: string): void;
} & React.ComponentProps<"input">;

export const SwiftInput: React.FC<SwiftInputProps> = ({
  className,
  ...props
}) => {
  const format = (value?: string) => {
    if (!value) return { text: "", template: "" };

    return {
      text: value,
      template: value.replace(/[a-zA-Z0-9-]/g, "x"),
    };
  };

  return (
    <Input
      parse={(character: string) => {
        if (/[a-zA-Z0-9-]/g.exec(character) === null) return;
        return character.toUpperCase();
      }}
      format={format}
      className={cn(
        'form-input block w-full rounded border border-gray-500 p-2 text-sm leading-5.5 text-gray-900 placeholder-gray-500 outline-none transition duration-300 hover:border-gray-700 focus:border-gray-700 focus:ring-gray-700 disabled:cursor-not-allowed disabled:border-gray-300 disabled:text-gray-300 disabled:placeholder-gray-300 aria-[invalid="true"]:border-red-600 aria-[invalid="true"]:focus:ring-red-600',
        className,
      )}
      {...props}
    />
  );
};

SwiftInput.displayName = "SwiftInput";
